import React, {Component} from 'react';
import {connect} from 'react-redux';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css'

import * as customizationActions from '../../actions/customization';
import ImportFile from "./ImportFile";
import './index.scss';
import {checkSession} from "../../api/api";
import ColorPicker from "./ColorPicker";
import logo from "./DefaultLogo.svg";
import previewLoginScreen from "./WebAppConfigSample_489x295.png";
import Message from "../Message";
import * as messageConstants from "../../shared/messages";
import IdpMetadataPopup from "../AddSAML/IdpMetadataPopup/IdpMetadataPopup";
import * as idpActions from '../../actions/idp';
import {MESSAGE_EVENT_TYPE} from "../../constants/postMessages";
import OidcIdpMetadataPopup from "../OidcApp/IdpOidcMetadataPopup/OidcIdpMetadataPopup";
import {OIDC} from "../../constants/requiredCapabilitiesMapping";
import {getMappedCapabilities} from "../../actions/storage";
import KeyLengthSelector from './KeyLengthSelector';

const SECONDS_PER_HOUR = 3600;
const SECONDS_PER_DAY = SECONDS_PER_HOUR * 24;
const options = [
  {label: "30 min", value: 1800},
  {label: "2 hr", value: 2 * SECONDS_PER_HOUR},
  {label: "4 hr", value: 4 * SECONDS_PER_HOUR},
  {label: "8 hr", value: 8 * SECONDS_PER_HOUR},
  {label: "12 hr", value: 12 * SECONDS_PER_HOUR},
  {label: "1 day", value: SECONDS_PER_DAY},
  {label: "2 days", value: 2 * SECONDS_PER_DAY},
  {label: "4 days", value: 4 * SECONDS_PER_DAY},
  {label: "Never", value: 2147483647}
];
const imageMimeHeaders = [
  "89504e47",
  "47494638",
  "ffd8ffe0",
  "ffd8ffe1",
  "ffd8ffe2",
  "ffd8ffe3",
  "ffd8ffe8"
];
const imageTypes = ['image/gif', 'image/jpg', 'image/jpeg', 'image/png'];
const imageSizeLimit = 51200;

/**
 * CustomizeGlobalIdpSettings
 */
export class CustomizeGlobalIdpSettings extends Component { // eslint-disable-line react/prefer-stateless-function
  state = {
    organizationLogo: undefined,
    errors: undefined,
    backgroundColor: undefined,
    organizationLogoFile: undefined,
    sessionTimeout: options[2],
    customizationAlreadyLoaded: false,
  }
  handleFrameTasks = (e) => {
    console.log(e);
  }
  handleSaveCustomization = () => {
    this.props.saveCustomization({
      logo_image: this.state.organizationLogoFile,
      backgroundColor: this.state.backgroundColor,
      sessionTimeout: this.state.sessionTimeout
    });
  }
  handleSaveCustomizationCancelling = () => {
    this.setState({
      customizationAlreadyLoaded: false
    })
  }
  handleChangeSessionTimeout = (e) => {
    this.setState({
      sessionTimeout: e
    })
  }
  handleSelectColor = (color) => {
    this.setState({
      backgroundColor: color
    })
  }
  handleSelectImage = (event) => {
    let file = event.target.files[0];
    this.isAcceptableImageFile(file)
    .then(result => {
      if (result === true) {
        this.props.clearMessages();
        let contentReader = new FileReader();
        contentReader.onloadend = (loadEvent) => {
          this.setState({organizationLogo: loadEvent.target.result})
        }
        contentReader.readAsDataURL(file)
        this.setState({organizationLogoFile: file})
      } else {
        this.props.setErrorMessage(
            messageConstants.CUSTOMIZATION_IMAGE_WARNING);
      }
    }).catch(e => e);
  }
  isAcceptableImageFile = (file) => {
    return new Promise((resolve) => {
      if (file.size > imageSizeLimit || imageTypes.indexOf(file.type) === -1) {
        this.setState({organizationLogoFile: ''});
        resolve(false);
      }
      let mimeReader = new FileReader();
      mimeReader.onloadend = (e) =>
          resolve(this.isValidImageMimeType(new Uint8Array(e.target.result)));
      mimeReader.readAsArrayBuffer(file.slice(0, 4));
    });
  }
  isValidImageMimeType = (mimeBytes) => {
    let header = "";
    mimeBytes.forEach(byte => header += byte.toString(16));
    return imageMimeHeaders.indexOf(header) !== -1;
  }
  getCustomization = () => {
    this.props.getCustomization();
  }
  handleLoadCustomization = () => {
    this.setState({
      customizationAlreadyLoaded: true
    })
    if (this.props.customizationSettings.backgroundColorHex) {
      if (this.props.customizationSettings.backgroundColorHex.search('#')
          === -1) {
        this.setState({
          backgroundColor: "#"
          + this.props.customizationSettings.backgroundColorHex
        })
      } else {
        this.setState({
          backgroundColor: this.props.customizationSettings.backgroundColorHex
        })
      }
    } else {
      this.setState({
        backgroundColor: "#eeeeee"
      })
    }
    if (this.props.customizationSettings.sessionTimeout !== undefined) {
      this.setState({
        sessionTimeout: options.find((element) => {
          return element.value
              === this.props.customizationSettings.sessionTimeout;
        })
      })
    } else {
      this.setState({sessionTimeout: options[2]})
    }
    if (this.props.customizationSettings.logoUrl) {
      this.setState({
        organizationLogo: this.props.customizationSettings.logoUrl + "admin"
      })
    } else {
      this.setState({
        organizationLogo: window.PUBLIC_URL + logo
      })
    }
    if(this.props.customizationSettings.keySize){
      this.setState({
        keySize: this.props.customizationSettings.keySize
      })
    }
  }
  handleGetIdpMetadata = () => {
    this.props.getIdpMetadata();
  }
  handleShowModalIdpMetadata = () => {
    this.props.showIdpMetadataPopup();
  }
  handleHideModalIdpMetadata = () => {
    this.props.hideIdpMetadataPopup()
  }
  handleShowModalOidcIdpMetadata = () => {
    this.props.showOidcIdpMetadataPopup();
  }
  handleHideModalOidcIdpMetadata = () => {
    this.props.hideOidcIdpMetadataPopup()
  }

  componentDidMount() {
    if (checkSession(this.props.history)) {
      window.addEventListener(MESSAGE_EVENT_TYPE, this.handleFrameTasks);
      this.getCustomization();
      this.handleGetIdpMetadata();
    }
  }

  componentDidUpdate() {
    if (this.props.customizationSettings
        && !this.state.customizationAlreadyLoaded) {
      this.handleLoadCustomization()
    }
  }

  componentWillUnmount() {
    window.removeEventListener(MESSAGE_EVENT_TYPE, this.handleFrameTasks);
  }

  render() {
    const organizationLogoSize = {description: "50 KB", value: 50 * 1024}
    const capabilities = JSON.parse(getMappedCapabilities());
    const displayOidcIdpMetadataSection = capabilities ? capabilities[OIDC] : false;
    return (
        <div className="CustomizeGlobalIdpSettings-container">
          <div className="container">
            <Message successMessage={this.props.successMsg}
                     errorMessage={this.props.errorMsg
                     || this.props.idpErrorMsg}
                     clearMessages={this.props.clearMessages}
                     id="customizeIdpSettingsMessage"/>
            <div className="row">
              <div className="col-xs-10 col-sm-10 col-md-10">
                <h1 className="page-title">{messageConstants.CUSTOMIZATION_TITLE}</h1>
                <div className="section-description">
                  {messageConstants.CUSTOMIZATION_SUBTITLE}
                </div>
                <h2 className="section-title">
                  {messageConstants.CUSTOMIZATION_APPEARANCE_SECTION}
                </h2>
                <div className="section-description">
                  {messageConstants.CUSTOMIZATION_APPEARANCE_DESCRIPTION}
                </div>
                <div className="row">
                  <div className="col-xs-7 col-sm-7 col-md-7">
                    <div className="image-section-header">
                      {messageConstants.CUSTOMIZATION_BACKGROUND_COLOR}
                    </div>
                    <div>
                      <ColorPicker handler={this.handleSelectColor}
                                   color={this.state.backgroundColor}/>
                    </div>
                    <div>
                      <div className="image-section-header">
                        {messageConstants.CUSTOMIZATION_ORGANIZATION_LOGO}
                      </div>
                      <div>
                        <ImportFile name="Organization logo"
                                    fileSize={organizationLogoSize}
                                    imageName={this.state.organizationLogo}
                                    imageWidth="col-md-5 col-sm-5 col-xs-5"
                                    handleSelectedImage={this.handleSelectImage}
                                    value={this.state.organizationLogoFile}/>
                      </div>
                    </div>
                  </div>
                  <div
                      className="col-xs-5 col-sm-5 col-md-5 image-section-header">
                    <img alt={window.PUBLIC_URL + previewLoginScreen}
                         src={window.PUBLIC_URL + previewLoginScreen}
                         width="100%" height="60%"/>
                  </div>
                </div>
                <div className="pb-70"/>
                <div className="pb-20">
                  <h2 className="section-title">
                    {messageConstants.CUSTOMIZATION_SESSION_SECURITY_SECTION}
                  </h2>
                  <div className="section-description">
                    {messageConstants.CUSTOMIZATION_SESSION_SECURITY_DESCRIPTION}
                  </div>
                  <div className="row">
                    <div className="col-md-3 col-sm-4 col-xs-4">
                      <div
                          className="image-section-header">{messageConstants.TERMINATION_SESSION_DROPDOWN_LABEL}</div>
                      <Dropdown id="sessionTimeoutDropdown"
                                options={options}
                                onChange={this.handleChangeSessionTimeout}
                                value={this.state.sessionTimeout}/>
                    </div>
                  </div>

                </div>

                <h3 className="section-title">{messageConstants.SBA_METADATA_REQUIRED_SP}
                </h3>

                <div className="section-description">
                  {displayOidcIdpMetadataSection
                      ? messageConstants.SBA_METADATA_REQUIRED_SP_DESCRIPTION
                      : messageConstants.SBA_SAML_METADATA_REQUIRED_SP_DESCRIPTION}
                </div>

                <h3>{messageConstants.METADATA_HEADER}</h3>
                <div className="view-idp-metadata-block">
                  <button id="showModalIdpMetadataButton"
                      className="btn btn-link view-idp-metadata-button"
                          onClick={this.handleShowModalIdpMetadata}>{messageConstants.IDP_VIEW_AND_COPY_METADATA}
                  </button>
                  {displayOidcIdpMetadataSection ? (
                    <button id="showModalOidcIdpMetadataButton"
                            className="btn btn-link view-idp-metadata-button padding-top-10"
                            onClick={this.handleShowModalOidcIdpMetadata}>{messageConstants.OIDC_IDP_VIEW_AND_COPY_METADATA}
                    </button>
                  ) : null}
                </div>
                <IdpMetadataPopup
                    showModalIdpMetadata={this.props.showModalIdpMetadata}
                    handleHideModalIdpMetadata={this.handleHideModalIdpMetadata}
                    idpMetadata={this.props.idpMetadata}
                    idpMetadataXmlProp={this.props.idpMetadataXmlProp}
                />
                <OidcIdpMetadataPopup
                    showModalOidcIdpMetadata={this.props.showModalOidcIdpMetadata}
                    handleHideModalOidcIdpMetadata={this.handleHideModalOidcIdpMetadata}
                    idpMetadata={this.props.idpMetadata}
                />

                <KeyLengthSelector
                    keySize={this.state.keySize}
                    onChange={this.handleSetKeyLength}
                />

                <div className="action-row">
                  <button
                      id="cancelSaveCustomizationButton"
                      type="button"
                      className="btn btn-md btn-default"
                      onClick={this.handleSaveCustomizationCancelling}
                  >
                    {messageConstants.CANCEL}
                  </button>
                  &nbsp;
                  <button
                      id="saveCustomizationButton"
                      type="button"
                      className="btn btn-md btn-primary"
                      onClick={this.handleSaveCustomization}
                  >
                    {messageConstants.SBA_SAVE_BUTTON}
                  </button>
                </div>

              </div>
            </div>
          </div>
        </div>
    );
  }
  handleSetKeyLength = (len) => {
    this.setState({ keySize: len });
    this.props.saveCustomization({ keySize: len });
  }
}

const mapStateToProps = (state) => {
  return {
    credentials: state.auth.credentials,
    customizationSettings: state.customization.customizationSettings,
    idpMetadata: state.idp,
    showModalIdpMetadata: state.idp.showModalIdpMetadata,
    showModalOidcIdpMetadata: state.idp.showModalOidcIdpMetadata,
    errorMsg: state.customization.errorMsg,
    idpErrorMsg: state.idp.errorMsg,
    successMsg: state.customization.successMsg,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCustomization: () => {
      dispatch(customizationActions.getCustomization());
    },
    cancelSaveCustomization: () => {
      dispatch(customizationActions.cancelSaveCustomization());
    },
    saveCustomization: (customizationData) => {
      dispatch(customizationActions.saveCustomization(customizationData))
    },
    clearMessages: () => {
      dispatch(customizationActions.clearMessages())
    },
    setErrorMessage: (errorMessage) => {
      dispatch(customizationActions.setErrorMessage(errorMessage))
    },
    getIdpMetadata: () => {
      dispatch(idpActions.getIdpMetadata());
    },
    idpMetadataXmlProp: () => {
      dispatch(idpActions.downloadIdpMetadataXml());
    },
    showIdpMetadataPopup: () => {
      dispatch(idpActions.showIdpMetadataPopup());
    },
    hideIdpMetadataPopup: () => {
      dispatch(idpActions.hideIdpMetadataPopup());
    },
    showOidcIdpMetadataPopup: () => {
      dispatch(idpActions.showOidcIdpMetadataPopup());
    },
    hideOidcIdpMetadataPopup: () => {
      dispatch(idpActions.hideOidcIdpMetadataPopup());
    },
  }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CustomizeGlobalIdpSettings);
